import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        loading: false,
        businesses: {data: [], current_page: 1, total: 0, per_page: 10},
        invoices: {data: [], current_page: 1, total: 0, per_page: 10},
        invoice: null,
        recording_payment: false,
        updating_fee_rate: false,
        updating_business_status: false,
        previewing_generation: false,
        generation_preview: null,
        loading_unlock_info: false,
        unlock_info: null,
        paying_to_unlock: false,
        loading_my_invoices: false,
        my_invoices_info: null,
        paying_my_invoice: false,
    }, getters: {
        loading: state => state.loading,
        businesses: state => state.businesses,
        invoices: state => state.invoices,
        invoice: state => state.invoice,
        recording_payment: state => state.recording_payment,
        updating_fee_rate: state => state.updating_fee_rate,
        updating_business_status: state => state.updating_business_status,
        previewing_generation: state => state.previewing_generation,
        generation_preview: state => state.generation_preview,
        loading_unlock_info: state => state.loading_unlock_info,
        unlock_info: state => state.unlock_info,
        paying_to_unlock: state => state.paying_to_unlock,
        loading_my_invoices: state => state.loading_my_invoices,
        my_invoices_info: state => state.my_invoices_info,
        paying_my_invoice: state => state.paying_my_invoice,
    }, mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setBusinesses(state, data) {
            state.businesses = data
        },
        setInvoices(state, data) {
            state.invoices = data
        },
        setInvoice(state, data) {
            state.invoice = data
        },
        setRecordingPayment(state, val) {
            state.recording_payment = val
        },
        setUpdatingFeeRate(state, val) {
            state.updating_fee_rate = val
        },
        setUpdatingBusinessStatus(state, val) {
            state.updating_business_status = val
        },
        setPreviewingGeneration(state, val) {
            state.previewing_generation = val
        },
        setGenerationPreview(state, data) {
            state.generation_preview = data
        },
        setLoadingUnlockInfo(state, val) {
            state.loading_unlock_info = val
        },
        setUnlockInfo(state, data) {
            state.unlock_info = data
        },
        setPayingToUnlock(state, val) {
            state.paying_to_unlock = val
        },
        setLoadingMyInvoices(state, val) {
            state.loading_my_invoices = val
        },
        setMyInvoicesInfo(state, data) {
            state.my_invoices_info = data
        },
        setPayingMyInvoice(state, val) {
            state.paying_my_invoice = val
        },
    }, actions: {
        async getBusinessInvoicesSummary({commit}, filters) {
            try {
                commit('setLoading', true)
                const response = await api.getBusinessInvoicesSummary(filters);
                commit('setBusinesses', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async getBusinessInvoices({commit}, filters) {
            try {
                commit('setLoading', true)
                const response = await api.getBusinessInvoices(filters);
                commit('setInvoices', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async getBusinessInvoice({commit}, id) {
            try {
                commit('setLoading', true)
                const response = await api.getBusinessInvoice(id);
                commit('setInvoice', response.data);
                commit('setLoading', false)
                return response.data;
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
                return null;
            }
        },

        async recordBusinessInvoicePayment({commit}, {id, data}) {
            try {
                commit('setRecordingPayment', true)
                const response = await api.recordBusinessInvoicePayment(id, data);
                commit('setRecordingPayment', false)
                ElMessage.success(response.message || 'Payment recorded successfully!');
                return response;
            } catch (e) {
                commit('setRecordingPayment', false)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },

        async updateBusinessFeeRate({commit}, {businessId, data}) {
            try {
                commit('setUpdatingFeeRate', true)
                const response = await api.updateBusinessFeeRate(businessId, data);
                commit('setUpdatingFeeRate', false)
                ElMessage.success(response.message || 'Fee rate updated successfully!');
                return response;
            } catch (e) {
                commit('setUpdatingFeeRate', false)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },

        async disableBusiness({commit}, {businessId, data}) {
            try {
                commit('setUpdatingBusinessStatus', true)
                const response = await api.disableBusiness(businessId, data);
                commit('setUpdatingBusinessStatus', false)
                ElMessage.success(response.message || 'Business disabled.');
                return response;
            } catch (e) {
                commit('setUpdatingBusinessStatus', false)
                ElMessage.error(e.response?.data?.message || 'Unable to disable this business.');
                throw e;
            }
        },

        async enableBusiness({commit}, businessId) {
            try {
                commit('setUpdatingBusinessStatus', true)
                const response = await api.enableBusiness(businessId);
                commit('setUpdatingBusinessStatus', false)
                ElMessage.success(response.message || 'Business enabled.');
                return response;
            } catch (e) {
                commit('setUpdatingBusinessStatus', false)
                ElMessage.error(e.response?.data?.message || 'Unable to enable this business.');
                throw e;
            }
        },

        async previewBusinessInvoiceGeneration({commit}, filters) {
            try {
                commit('setPreviewingGeneration', true)
                commit('setGenerationPreview', null)
                const response = await api.previewBusinessInvoiceGeneration(filters);
                commit('setGenerationPreview', response.data);
                commit('setPreviewingGeneration', false)
                return response.data;
            } catch (e) {
                commit('setPreviewingGeneration', false)
                ElMessage.error(e.response.data.message);
                return null;
            }
        },

        async getUnlockInfo({commit}, token) {
            try {
                commit('setLoadingUnlockInfo', true)
                const response = await api.getUnlockInfo(token);
                commit('setUnlockInfo', response.data);
                commit('setLoadingUnlockInfo', false)
                return response.data;
            } catch (e) {
                commit('setLoadingUnlockInfo', false)
                commit('setUnlockInfo', null);
                return null;
            }
        },

        async payUnlockInvoice({commit}, data) {
            try {
                commit('setPayingToUnlock', true)
                const response = await api.payUnlockInvoice(data);
                commit('setPayingToUnlock', false)
                ElMessage.success(response.message || 'Payment request sent.');
                return response;
            } catch (e) {
                commit('setPayingToUnlock', false)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },

        async getMyBusinessInvoices({commit}) {
            try {
                commit('setLoadingMyInvoices', true)
                const response = await api.getMyBusinessInvoices();
                commit('setMyInvoicesInfo', response.data);
                commit('setLoadingMyInvoices', false)
                return response.data;
            } catch (e) {
                commit('setLoadingMyInvoices', false)
                commit('setMyInvoicesInfo', null);
                return null;
            }
        },

        async payMyBusinessInvoice({commit}, data) {
            try {
                commit('setPayingMyInvoice', true)
                const response = await api.payMyBusinessInvoice(data);
                commit('setPayingMyInvoice', false)
                ElMessage.success(response.message || 'Payment request sent.');
                return response;
            } catch (e) {
                commit('setPayingMyInvoice', false)
                ElMessage.error(e.response?.data?.message || 'Unable to send payment request.');
                throw e;
            }
        },

        // Pure passthrough, deliberately no commits/toasts here - unlike
        // the older payments/getPaymentStatus action (which owns its own
        // setInterval and fires toasts/confirm() dialogs internally), the
        // pay pages that use this own their own poll loop so they can show
        // the failure reason inline and control exactly when polling
        // starts/stops/restarts (reinitiating a payment needs a clean
        // restart, not a second interval stacking on top of the first).
        async checkMyInvoiceCheckoutStatus({commit}, checkoutRequestId) {
            return api.getPaymentStatus({checkout_request_id: checkoutRequestId});
        },
    }
}
